import React, { useState, useRef, useEffect } from "react";
import Modal from "./Modal";
import { ShieldCheck, Loader2, CheckCircle2 } from "lucide-react";

export default function VerificationModal({ isOpen, onClose, onVerified, onVerifyCode }) {
  const [digits, setDigits] = useState(["", "", "", ""]);
  const [error, setError] = useState("");
  const [loading, setLoading] = useState(false);
  const [verified, setVerified] = useState(false);
  const inputRefs = useRef([]);

  useEffect(() => {
    if (isOpen) {
      setDigits(["", "", "", ""]);
      setError("");
      setLoading(false);
      setVerified(false);
      setTimeout(() => {
        inputRefs.current[0]?.focus();
      }, 300);
    }
  }, [isOpen]);

  const handleChange = (index, value) => {
    if (!/^\d*$/.test(value)) return;
    const newDigits = [...digits];
    newDigits[index] = value.slice(-1);
    setDigits(newDigits);
    setError("");

    if (value && index < 3) {
      inputRefs.current[index + 1]?.focus();
    }

    if (index === 3 && value) {
      const code = [...newDigits.slice(0, 3), value.slice(-1)].join("");
      handleVerify(code);
    }
  };

  const handleKeyDown = (index, e) => {
    if (e.key === "Backspace" && !digits[index] && index > 0) {
      inputRefs.current[index - 1]?.focus();
    }
  };

  const handleVerify = async (code) => {
    setLoading(true);
    setError("");
    try {
      await onVerifyCode(code);
      setVerified(true);
      setTimeout(() => {
        onVerified();
      }, 1200);
    } catch (err) {
      setError(err.message || "Doğrulama kodu hatalı. Lütfen tekrar deneyin.");
      setDigits(["", "", "", ""]);
      inputRefs.current[0]?.focus();
    } finally {
      setLoading(false);
    }
  };

  return (
    <Modal isOpen={isOpen} onClose={onClose} title={null}>
      <div style={{ textAlign: "center" }}>
        {verified ? (
          <div style={{ padding: "1rem 0" }}>
            <div className="verify-success-icon">
              <CheckCircle2 />
            </div>
            <h3 className="verify-success-title">Randevunuz Onaylandı!</h3>
            <p className="verify-success-text">
              Randevunuz başarıyla oluşturuldu. Teşekkür ederiz!
            </p>
          </div>
        ) : (
          <>
            <div className="verify-icon">
              <ShieldCheck />
            </div>
            <h3 className="verify-title">SMS Doğrulaması</h3>
            <p className="verify-subtitle">
              Telefonunuza gönderilen 4 haneli doğrulama kodunu girin.
            </p>

            {/* Code Inputs */}
            <div className="verify-inputs">
              {digits.map((digit, index) => (
                <input
                  key={index}
                  ref={(el) => (inputRefs.current[index] = el)}
                  type="text"
                  inputMode="numeric"
                  maxLength={1}
                  value={digit}
                  onChange={(e) => handleChange(index, e.target.value)}
                  onKeyDown={(e) => handleKeyDown(index, e)}
                  className={`verify-input ${error ? "error" : digit ? "filled" : ""}`}
                  disabled={loading}
                />
              ))}
            </div>

            {error && <p className="verify-error">{error}</p>}

            {loading && (
              <div className="verify-loading">
                <Loader2 />
                <span>Doğrulanıyor...</span>
              </div>
            )}
          </>
        )}
      </div>
    </Modal>
  );
}
